<template>
  <div class="grid w-full gap-4 grid-cols-[repeat(auto-fit,_minmax(112px,_1fr))]">
    <AssortmentIcon v-for="(tile, index) in tiles" :key="index" :content="tile" />
  </div>
</template>

<script setup lang="ts">
type ContentfulAssortmentIcon = {
  fields: {
    icon: {
      fields: {
        file: {
          url: string;
        };
      };
    };
    title: string;
    linkUrl: string;
  };
};

type ContentfulAssortmentIcons = {
  fields: {
    assortmentIcons: ContentfulAssortmentIcon[];
  };
};

type Props = {
  content: ContentfulAssortmentIcons;
};

const props = defineProps<Props>();

const tiles = computed(() => {
  return props.content?.fields.assortmentIcons || [];
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'AssortmentIcons',
});
</script>
